export default [
    {
        header: 'Dashboards',
    },
    {
        title: 'Realtime',
        route: { name: 'project-frontend-dashboard-realtime' },
        icon: 'HomeIcon',
        resource: 'Project',
        action: 'read',
    },
    {
        title: 'Daily',
        route: { name: 'project-frontend-dashboard-daily' },
        icon: 'HomeIcon',
        resource: 'Project',
        action: 'read',
    },
    {
        title: 'Monthly',
        route: { name: 'project-frontend-dashboard-monthly' },
        icon: 'HomeIcon',
        resource: 'Project',
        action: 'read',
    },
]
